import Vue, { CreateElement } from 'src/vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import BlogPost from '@src/data/blog-post'
import { H5, Overline } from '@src/elements/typography/typography'
import { convertDateTo } from '@src/util/date-format'

import './post.sass'

@Component({
  computed: {
    locale () {
      return this.$store.state.i18n.locale
    }
  }
})

export class Post extends Vue {

  @Prop({ required: true })
  private post: BlogPost
  private locale: string
  private selectedLanguage: string = 'En'
  private localLanguage: string = this.setLanguageName(this.$store.state.i18n.locale)

  constructor () {
    super()
    this.selectedLanguage = this.post.getLanguages().includes(this.localLanguage) ? this.localLanguage : 'En'
  }

  created () {
    this.setLocalLanguage()
  }

  changeLanguage (lang: string) {
    this.selectedLanguage = lang
    // when changing the language, remove the preselected value
    this.post.preselectedLanguage = undefined
  }

  setLanguageName (languages): string {
    let language
    switch (languages.substring(0, 2)) {
      case 'de':
        language = 'De'
        break
      case 'en':
        language = 'En'
        break
      case 'ja':
        language = 'Jp'
        break
      default:
        break
    }
    return language
  }

  render (h: CreateElement) {
    let languages = this.post.getLanguages().map((lang: string) => {
      /* istanbul ignore else: getLanguages only lists the languages with content */
      if (this.post[`content${lang}`]) {
        return <div onClick={() => this.changeLanguage(lang)} class={`lang ${(this.post.preselectedLanguage || this.selectedLanguage) !== lang ? '' : 'selected'}`}>
          <Overline>{lang.toUpperCase()}</Overline>
        </div>
      }
    })

    return <div class='post'>
      <div class='header'>
        <div>
          {convertDateTo(this.post.publishedAt, 'dddd, MMMM D, YYYY')}
          <span class='time'>{convertDateTo(this.post.publishedAt, 'HH:mm')}</span>
        </div>
        <div class='lang-switcher'>
          {languages}
        </div>
      </div>

      <div class='body'>
        <H5 class='post-title'>{this.post[`title${this.post.preselectedLanguage || this.selectedLanguage}`]}</H5>
        <div domPropsInnerHTML={this.post[`content${this.post.preselectedLanguage || this.selectedLanguage}`]} />
      </div>

      <div class='footer'>
        <div>{`${this.$t('PAGE.BLOG.AUTHOR')}: ${this.post.author}`}</div>
        <div>{`${this.$t('CONTACT')}: `}<a href={`mailto:${this.post.contact}`}>{this.post.contact}</a></div>
      </div>
    </div>
  }

  @Watch('locale')
  private setLocalLanguage () {
    this.localLanguage = this.setLanguageName(this.locale)
    this.selectedLanguage = this.post.getLanguages().includes(this.localLanguage) ? this.localLanguage : 'En'
  }
}
